import React, { FC, useMemo } from 'react';

import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import { ArchivalUnitCopy } from 'types';
import { levelIcon } from '../grid-hooks/breadcrumbs-hook';
import { useEadTreeContext } from './EadTreeCtx';
import { ListVariants, useVariantContext } from './VariantCtx';

type Props = {
  archivalUnitCopy: ArchivalUnitCopy;
  level: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    active: {
      backgroundColor: theme.palette.primary.dark,
      color: 'white!important',
      padding: '0px 4px',
    },
    link: {
      color: 'white',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    icon: {
      marginRight: 4,
      fontSize: 11,
    },
  })
);
const variantToPath: Record<ListVariants, string> = {
  aids: 'pomucky',
  funds: 'fondy',
};
const ArchivalUnitItem: FC<Props> = ({ archivalUnitCopy, level = 2 }) => {
  const { crumbs } = useEadTreeContext();
  const variant = useVariantContext();
  const { id } = useParams<{
    id: string;
  }>();

  const isActive = useMemo(() => {
    return crumbs?.some((c) => c.id === archivalUnitCopy?.id);
  }, [crumbs, archivalUnitCopy?.id]);

  const classes = useStyles();
  const Icon = levelIcon['item'];

  return (
    <div
      style={{
        paddingLeft: 10,
      }}
    >
      <span
        className={`${classes.link} ${
          isActive && archivalUnitCopy?.id === id ? classes.active : ''
        }`}
      >
        <span>
          <Icon className={classes.icon} />
        </span>
        <Link
          className={`${classes.link} ${
            isActive && archivalUnitCopy?.id === id ? classes.active : ''
          }`}
          to={`/${variantToPath[variant!]}/${level}/${archivalUnitCopy?.id}/`}
        >
          {archivalUnitCopy?.label}
        </Link>
      </span>
      <br />
    </div>
  );
};
export default ArchivalUnitItem;
